import { Plus } from "lucide-react"
import { t } from "../../i18n"

export default function AddCompanyButton({
  onClick,
  disabled = false,
}: {
  onClick: () => void
  disabled?: boolean
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 font-source font-semibold text-white disabled:opacity-60"
    >
      <Plus size={18} aria-hidden="true" />
      {t("companies.add")}
    </button>
  )
}
